import { AppBar, Box, Button, Container, FormControl, InputLabel, MenuItem, Select, Stack, Tab, Tabs, TextField, Typography, useMediaQuery } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { basicSchema } from "./validation";
import './checkout.css'
import { useTheme } from '@mui/material/styles';
import { useAddAddressMutation, useGetCartQuery, useGetUserAddressesQuery } from '../../features/fullApi';
import { toast } from 'react-hot-toast';
import Address from '../User/Address';
import PropTypes from 'prop-types';
import ConfirmAddressDialog from '../Modals/ConfirmAddressDialog';
import { Country, State, City }  from 'country-state-city';


const AddressForm = ({getAddress}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  window.scrollTo(0, 0);
  const navigate = useNavigate()

  const goToPayment = async (values) => {
    if(userAddresses.length < 3 && saveNewAddress) {
        setOpenAddress(true)
    } else {
      navigate(`/checkout/${user._id}`)
      console.log("values", values)
      values.country = country.name
      values.state = state.name
      values.city = city.name
      values.countryCode = countryCode
      getAddress(values)
    }
  };

  let indexP = 0;

  const onSubmit = async (values) => {

  }

  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [openAddress, setOpenAddress] = useState(false)

  

  const countries = Country.getAllCountries()
  const allStates = State.getAllStates()

  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])


  const handleChangeCountry = (e) => {
    console.log("E ON COUNTRY", e)
    setCountry(e)
    setStates(State.getStatesOfCountry(e.isoCode))
    console.log("STATES", states)
    setCountryCode(e.isoCode)
    setCity("")
  }

  const handleChangeState = (e) => {
    console.log("E ON STATE", e.name)
    setState(e)
    setCities(City.getCitiesOfState(e.countryCode, e.isoCode))
    handleChangeCity(City.getCitiesOfState(e.countryCode, e.isoCode).filter(city => city.name ===  userAddresses[indexP].city)[0])
  }

  const handleChangeCity = (e) => {
    console.log("hcs", e)
    setCity(e)
  }

  const [addAddress] = useAddAddressMutation()
  const handleSaveAddress = () => {
    console.log("country", country.name)
    console.log("state", state.name)
    console.log("city", city.name)
    addAddress({userId: user?._id, name: values.name, surname: values.surname, country: country.name,
      street: values.street, state: state.name, city:city.name, zipcode: values.zipcode, countryCode: values.countryCode}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }).then(res => {
          toast.success("Address successfully created")
          navigate(`/checkout/${user._id}`)
          console.log("values", values)
          setOpenAddress(false)
          values.country = country.name
          values.state = state.name
          values.city = city.name
          values.addressId = res.data._id
          getAddress(values)
        }
      ).catch(err => {
          console.log("ERR", err)
      })
  }

  const {data: cartData, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);
  useEffect(() => {
    if(!cartIsLoading) {
      //daca cosul nu i activ
      if(!cartData.isActive) {
        toast("some of the products in your cart are not available anymore")
      }
    } 
  }, [cartIsLoading])

  
  const [saveNewAddress, setSaveNewAddress]  = useState(true)

  
  const [view, setView] = useState(false)


  const {data:userAddresses, error:errorUserAddresses, isLoading:isLoadingUserAddresses} = useGetUserAddressesQuery({id: user._id});

  useEffect(() => {
    userAddresses?.map((address, index) => {
      if(index === 0) {
        values.name = userAddresses[0].name
        values.surname = userAddresses[0].surname
        values.city = userAddresses[0].city
        values.countryCode = userAddresses[0].countryCode
        setCountry(userAddresses[0].country)
        handleChangeCountry(countries.filter(country => country.name===userAddresses[0].country)[0])
        handleChangeState(allStates.filter(state => state.name===userAddresses[0].state)[0])
        console.log("State is", state)
        values.street = userAddresses[0].street
        values.zipcode = userAddresses[0].zipcode
      }
    })
  }, [isLoadingUserAddresses])

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      surname: "",
      street: "",
      zipcode: "",
      city: "",
      country: "",
      state: "",
      countryCode: "",
      addressId: "",
    },
    onSubmit,
  });

  const [address, setAddress] = useState('');

  useEffect(() => {
    if(!isLoadingUserAddresses && userAddresses.length > 0) {
      values.addressId = userAddresses[0]._id
      setSaveNewAddress(false)
      setAddress(userAddresses[0])
      values.name = userAddresses[0].name
      values.surname = userAddresses[0].surname
      values.countryCode = userAddresses[0].countryCode
      setCity(userAddresses[0].city)
      handleChangeCountry(countries.filter(country => country.name===userAddresses[0].country)[0])
      handleChangeState(allStates.filter(state => state.name===userAddresses[0].state)[0])
      values.street = userAddresses[0].street
      values.zipcode = userAddresses[0].zipcode
    }
  }, [isLoadingUserAddresses])
  
  const handleChangeAddress = (event) => {
    setSaveNewAddress(false)
    console.log("EVENT IS", event.target.value)
    console.log("index is", indexP)
    values.addressId = event.target.value._id
    setAddress(event.target.value);
    values.name = event.target.value.name
    values.surname = event.target.value.surname
    setCity(event.target.value.city)
    values.street = event.target.value.street
    values.zipcode = event.target.value.zipcode
    values.countryCode = event.target.value.countryCode
    console.log(event.target.value.userId)
    indexP = userAddresses.map(item => item._id).indexOf(event.target.value._id)
    console.log("INDEX P IS", indexP)
    handleChangeCountry(countries.filter(country => country.name===event.target.value.country)[0])
    handleChangeState(allStates.filter(state => state.name===event.target.value.state)[0])
  };

  const clearForm = () => {
    setSaveNewAddress(true)
    setAddress("")
    values.name = ""
    values.surname = ""
    setCity("")
    setState("")
    setCountry("")
    values.street = ""
    values.zipcode = ""
    values.city = ""
  }

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  

  const renderMobileAddressForm = () => (
    <Container style={{marginTop: '100px', height: '100%'}}>
    {!isLoadingUserAddresses &&
    <Container>
    {!view && (userAddresses.length > 0) &&
      <Container>
      <h4 className="center" style={{margin: '0px'}}>Select from saved or create new</h4>  
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Button variant="contained" size="small" style={{width: '75px', margin: '10px'}} onClick={() => clearForm()}>New</Button>
      </div>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <FormControl fullWidth size="small">
        <InputLabel id="addressSelectLabel">Address</InputLabel>
        <Select
          labelId="addressSelect"
          id="addressSelect"
          value={address}
          label="Address"
          onChange={handleChangeAddress}
          size="small"
        >
        {userAddresses?.map((option) => (
            <MenuItem key={option._id} value={option}>
                {option.city + " - " +  option.street}
            </MenuItem>
        ))}
        </Select>
      </FormControl>
      </div>
      </Container>
    }
          <Container style={{margin: '40px 0'}}>
            <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off">
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <h2 className="center">Billing Address</h2>
              </div>
              <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <TextField
                  id="name"
                  type="text"
                  value={values.name}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="name"
                  margin="dense"
                  size="small"
                />
              </FormControl>
              {errors.name && touched.name && <p className="error">{errors.name}</p>}

              <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
                  id="surname"
                  type="text"
                  margin="dense"
                  value={values.surname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="surname"
                  size="small"
              />
              </FormControl>
              {errors.surname && touched.surname && (
                <p className="error">{errors.surname}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>Country</InputLabel>
                <Select
                  id="country"
                  value={country}
                  label="Country"
                  onChange={(e) => handleChangeCountry(e.target.value)}
                >
                    {countries?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.country && touched.country && (
                <p className="error">{errors.country}</p>
              )}
        
            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>State</InputLabel>
                <Select
                  id="state"
                  value={state}
                  label="State"
                  onChange={(e) => handleChangeState(e.target.value)}
                >
                    {states?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.state && touched.state && (
                <p className="error">{errors.state}</p>
              )}


            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>City</InputLabel>
                <Select
                  id="state"
                  value={city}
                  label="State"
                  onChange={(e) => handleChangeCity(e.target.value)}
                >
                    {cities.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.city && touched.city && (
                <p className="error">{errors.city}</p>
              )}

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <TextField
                  id="street"
                  type="text"
                  value={values.street}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="street"
                  margin="dense"
                  size="small"
                />
              </FormControl>
              {errors.street && touched.street && <p className="error">{errors.street}</p>}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="zipcode"
              type="number"
              margin="dense"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="zipcode"
              size="small"
            />
            </FormControl>
              {errors.zipcode && touched.zipcode && (
                <p className="error">{errors.zipcode}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
              id="countryCode"
              type="text"
              margin="dense"
              value={countryCode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Country Code"
              size="small"
              disabled
            />
            </FormControl>
              {errors.countryCode && touched.countryCode && (
                <p className="error">{errors.countryCode}</p>
              )}


              <Stack justifyContent="center" alignItems="center">
                <Button onClick={() => goToPayment(values)} type="submit" variant="contained" color="primary" id="submitBtn" style={{width: '150px'}}>
                  Checkout
                </Button>
              </Stack>
            </form>
          </Container>
          <ConfirmAddressDialog openAddress={openAddress} handleSaveAddress={handleSaveAddress} setOpenAddress={setOpenAddress} item={address}></ConfirmAddressDialog>
    </Container>}
    </Container>
  )

  const renderTabletAddressForm = () => (
    <Container style={{marginTop: '100px', height: '100vh'}}>
    {!isLoadingUserAddresses &&
    <Container>
    {!view && (userAddresses.length > 0) &&
      <Container>
      <h4 className="center" style={{margin: '0px'}}>Select from saved or create new</h4>  
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Button variant="contained" size="small" style={{width: '75px', margin: '10px'}} onClick={() => clearForm()}>New</Button>
      </div>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <FormControl fullWidth>
        <InputLabel id="addressSelectLabel">Address</InputLabel>
        <Select
          labelId="addressSelect"
          id="addressSelect"
          value={address}
          label="Address"
          onChange={handleChangeAddress}
        >
        {userAddresses?.map((option) => (
            <MenuItem key={option._id} value={option}>
                {option.city + " - " +  option.street}
            </MenuItem>
        ))}
        </Select>
      </FormControl>
      </div>
      </Container>
    }
          <Container style={{margin: '40px 0'}}>
            <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off">
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <h2 className="center">Billing Address</h2>
              </div>
              <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <TextField
                  id="name"
                  type="text"
                  value={values.name}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="name"
                  margin="dense"
                  size="small"
                />
              </FormControl>
              {errors.name && touched.name && <p className="error">{errors.name}</p>}

              <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
                  id="surname"
                  type="text"
                  margin="dense"
                  value={values.surname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="surname"
                  size="small"
              />
              </FormControl>
              {errors.surname && touched.surname && (
                <p className="error">{errors.surname}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>Country</InputLabel>
                <Select
                  id="country"
                  value={country}
                  label="Country"
                  onChange={(e) => handleChangeCountry(e.target.value)}
                >
                    {countries?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.country && touched.country && (
                <p className="error">{errors.country}</p>
              )}
        
            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>State</InputLabel>
                <Select
                  id="state"
                  value={state}
                  label="State"
                  onChange={(e) => handleChangeState(e.target.value)}
                >
                    {states?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.state && touched.state && (
                <p className="error">{errors.state}</p>
              )}


            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>City</InputLabel>
                <Select
                  id="state"
                  value={city}
                  label="State"
                  onChange={(e) => handleChangeCity(e.target.value)}
                >
                    {cities.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.city && touched.city && (
                <p className="error">{errors.city}</p>
              )}

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <TextField
                  id="street"
                  type="text"
                  value={values.street}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="street"
                  margin="dense"
                  size="small"
                />
              </FormControl>
              {errors.street && touched.street && <p className="error">{errors.street}</p>}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="zipcode"
              type="number"
              margin="dense"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="zipcode"
              size="small"
            />
            </FormControl>
              {errors.zipcode && touched.zipcode && (
                <p className="error">{errors.zipcode}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
              id="countryCode"
              type="text"
              margin="dense"
              value={countryCode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Country Code"
              size="small"
              disabled
            />
            </FormControl>
              {errors.countryCode && touched.countryCode && (
                <p className="error">{errors.countryCode}</p>
              )}


              <Stack justifyContent="center" alignItems="center">
                <Button onClick={() => goToPayment(values)} type="submit" variant="contained" color="primary" id="submitBtn" style={{width: '150px'}}>
                  Checkout
                </Button>
              </Stack>
            </form>
          </Container>
          <ConfirmAddressDialog openAddress={openAddress} handleSaveAddress={handleSaveAddress} setOpenAddress={setOpenAddress} item={address}></ConfirmAddressDialog>
    </Container>}
    </Container>
  )

  const renderDesktopAddressForm = () => (
    <Container style={{marginTop: '100px', height: '100vh', maxWidth:'600px'}}>
    {!isLoadingUserAddresses &&
    <Container>
    {!view && (userAddresses.length > 0) &&
      <Container>
      <Typography variant="h6" className="center" style={{margin: '0px'}}>Select from saved or create new</Typography>  
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Button variant="contained" size="large" style={{width: '150px', margin: '10px'}} onClick={() => clearForm()}>New</Button>
      </div>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <FormControl fullWidth>
        <InputLabel id="addressSelectLabel">Address</InputLabel>
        <Select
          labelId="addressSelect"
          id="addressSelect"
          value={address}
          label="Address"
          onChange={handleChangeAddress}
        >
        {userAddresses?.map((option) => (
            <MenuItem key={option._id} value={option}>
                {option.city + " - " +  option.street}
            </MenuItem>
        ))}
        </Select>
      </FormControl>
      </div>
      </Container>
    }
          <Container style={{margin: '40px 0'}}>
            <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off">
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <h2 className="center">Billing Address</h2>
              </div>
              <FormControl fullWidth style={{marginBottom: '10px'}}>
                <TextField
                  id="name"
                  type="text"
                  value={values.name}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="name"
                  margin="dense"
                />
              </FormControl>
              {errors.name && touched.name && <p className="error">{errors.name}</p>}

              <FormControl fullWidth style={{marginBottom: '10px'}}>
              <TextField
                  id="surname"
                  type="text"
                  margin="dense"
                  value={values.surname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="surname"
              />
              </FormControl>
              {errors.surname && touched.surname && (
                <p className="error">{errors.surname}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}}>
                <InputLabel>Country</InputLabel>
                <Select
                  id="country"
                  value={country}
                  label="Country"
                  onChange={(e) => handleChangeCountry(e.target.value)}
                >
                    {countries?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.country && touched.country && (
                <p className="error">{errors.country}</p>
              )}
        
            <FormControl fullWidth style={{marginBottom: '10px'}}>
                <InputLabel>State</InputLabel>
                <Select
                  id="state"
                  value={state}
                  label="State"
                  onChange={(e) => handleChangeState(e.target.value)}
                >
                    {states?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.state && touched.state && (
                <p className="error">{errors.state}</p>
              )}


            <FormControl fullWidth style={{marginBottom: '10px'}}>
                <InputLabel>City</InputLabel>
                <Select
                  id="state"
                  value={city}
                  label="State"
                  onChange={(e) => handleChangeCity(e.target.value)}
                >
                    {cities.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.city && touched.city && (
                <p className="error">{errors.city}</p>
              )}

          <FormControl fullWidth style={{marginBottom: '10px'}}>
                <TextField
                  id="street"
                  type="text"
                  value={values.street}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="street"
                  margin="dense"
                />
              </FormControl>
              {errors.street && touched.street && <p className="error">{errors.street}</p>}

            <FormControl fullWidth style={{marginBottom: '10px'}}>
            <TextField
              id="zipcode"
              type="number"
              margin="dense"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="zipcode"
            />
            </FormControl>
              {errors.zipcode && touched.zipcode && (
                <p className="error">{errors.zipcode}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}}>
              <TextField
              id="countryCode"
              type="text"
              margin="dense"
              value={countryCode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Country Code"
              disabled
            />
            </FormControl>
              {errors.countryCode && touched.countryCode && (
                <p className="error">{errors.countryCode}</p>
              )}


              <Stack justifyContent="center" alignItems="center">
                <Button size="large" onClick={() => goToPayment(values)} type="submit" variant="contained" color="primary" style={{width: '150px'}}>
                  Checkout
                </Button>
              </Stack>
            </form>
          </Container>
          <ConfirmAddressDialog openAddress={openAddress} handleSaveAddress={handleSaveAddress} setOpenAddress={setOpenAddress} item={address}></ConfirmAddressDialog>
    </Container>}
    </Container>
  )

  return (
    (isXs | isSm) ? renderMobileAddressForm() : 
    (isMd) ? renderTabletAddressForm() :
    renderDesktopAddressForm()
  );
};

export default AddressForm;